import { useEffect, useState } from "react";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import { toDateString } from "../../../../common/helper";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DashboardService } from "../../../../services/DashboardService";
import SortedHeader from "../../../../components/Tables/SortedHeader";
import IconThreeDots from "../../../../layout/others/three-dots.svg";
import "bootstrap/dist/js/bootstrap.bundle";
import "../../../styles/styles.scss";
import "../../../styles/tables.scss";
import "moment/locale/pt";

export default function InterviewDocList() {
  const history = useHistory();
  const [interviewList, setInterviewList] = useState([]);
  const [totalPages, SetTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchObject, setSearchObject] = useState({});
  const pageSize = 10;
  const [isInterviewsLoading, setIsInterviewsLoading] = useState(true);
  const { t } = useTranslation();

  const [headers, setHeaders] = useState([
    { label: t("Name"), field: "Name" },
    { label: t("Email"), field: "Email" },
    { label: t("Mobile number"), field: "Mobile" },
    { label: t("Tech Area"), field: "TechArea" },
    { label: t("Tech Role"), field: "TechRole" },
    { label: t("Date"), field: "Date", sorted: true }
  ]);

  useEffect(() => {
    GetData();
  }, []);

  useEffect(() => (document.title = t("AtVitae - Interviews")), [t]);

  useEffect(() => {
    GetData();
  }, [pageNumber, searchObject]);

  function GetData() {
    DashboardService.getCardDocOnlineInterview(
      pageSize,
      pageNumber,
      searchObject
    )
      .then((interviewResponse) => {
        setInterviewList(interviewResponse.page);
        SetTotalPages(Math.ceil(interviewResponse.total / pageSize));
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("Something went wrong."));
      })
      .finally(() => {
        setIsInterviewsLoading(false);
      });
  }

  function openDOCOnlineEdit(event, docOnlineId) {
    event.stopPropagation();
    window.open(`/interviews/DOCEdit/${docOnlineId}`);
  }

  const openInterviewPage = (interview) => {
    if (interview.interviewId)
      history.push(`interview/view/${interview.interviewId}`);
    else
      history.push(`precandidate?precandidateId=${interview.precandidateId}`);
  };

  return (
    <>
      <div className="table-wrap interview-list">
        {isInterviewsLoading ? (
          <>
            <table>
              <thead>
                <tr className="precandidates-header-row text-nowrap">
                  {headers.map((header) => (
                    <th>
                      <span className="header-label">{header.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </>
        ) : (
          <table className="table-responsive">
            <thead>
              <SortedHeader
                headers={headers}
                setHeaders={setHeaders}
                searchObject={searchObject}
                setSearchObject={setSearchObject}
              />
            </thead>
            <tbody>
              {interviewList.map((interview, index) => (
                <tr key={index} onClick={() => openInterviewPage(interview)}>
                  <td className="name text-truncate" title={interview.name}>
                    {t(interview.name)}
                  </td>
                  <td className="email text-truncate" title={interview.email}>
                    {interview.email}
                  </td>
                  <td className="phone text-truncate" title={interview.mobile}>
                    {interview.mobile}
                  </td>
                  <td className="role text-truncate" title={interview.techArea}>
                    {t(interview.techArea)}
                  </td>
                  <td className="role text-truncate" title={interview.techRole}>
                    {t(interview.techRole)}
                  </td>
                  <td
                    className="date text-truncate"
                    title={moment(interview.date).format("DD-MM-YYYY")}
                    id="contactDate"
                  >
                    {toDateString(interview.date)}
                  </td>
                  <td>
                    <div className="dropdown">
                      <button
                        className="action-button"
                        type="button"
                        id="export"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={IconThreeDots}
                          alt="threedots"
                          title={t("Options")}
                        />
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="more">
                        <li>
                          <a
                            href="#!"
                            className="dropdown-item"
                            title={t("Edit DocOnline")}
                            data-bs-toggle="tooltip"
                            onClick={(event) => {
                              openDOCOnlineEdit(event, interview.docOnlineId);
                            }}
                          >
                            {t("Edit DocOnline")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
              {interviewList.length === 0 && (
                <div className="table-message">{t("No interviews found.")}</div>
              )}
            </tbody>
          </table>
        )}
      </div>
      <div className="row">
        <div className="text-end">
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      </div>
    </>
  );
}
